
export * from './tooltips.component';
export * from './tooltips.module';